// extracted by mini-css-extract-plugin
module.exports = {"benefitContainer":"styles-module--benefitContainer--1ls94","light":"styles-module--light--1KGo1","medium":"styles-module--medium--3fXKZ","dark":"styles-module--dark--1QBSF"};